/**
 * Состояние боя
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Создаёт начальное состояние боя
 * @returns {object} Объект состояния боя
 */
export function createInitialBattleState() {
  return {
    battle: null,
    panels: [],
    timeline: [],
    currentStep: 0,
    isPlaying: false,
    timer: null,
    speed: 1000,
    lastRenderedStep: -1,
    autoTimeouts: [],
    winner: null,
    telemetryByRound: {},
  };
}

/**
 * Создаёт начальное состояние PvP
 * @returns {object} Объект состояния PvP
 */
export function createInitialPvpState() {
  return {
    queueId: null,
    pollTimer: null,
    startedAt: 0,
    statusText: "PvP: поиск не активен",
  };
}











